/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import JSG from '@cedalo/jsg-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { deleteStreamSheet, setAppState } from '../../../actions/actions';
import { graphManager } from '../../../GraphManager';
import Divider from '@mui/material/Divider';
import DialogButton from '../../utils/DialogButton';

class SheetDeleteDialog extends React.Component {
	handleSubmitDeleteSheet = () => {
		const count = JSG.streamSheets.length;

		this.props.deleteStreamSheet(this.props.machineId, this.props.sheet.id, { id: this.props.scopeId });
		this.props.close();

		const resetIndex = (container) => {
			let current = container.activeSheetIndex;
			current = Math.min(count - 2, current);

			container.setActiveSheetIndex(current, graphManager.getGraphViewer());
		};

		const container = graphManager.getGraph().streamSheetsContainer;
		resetIndex(container.leftSheetContainer);
		resetIndex(container.rightSheetContainer);

		// force add button to rerender
		setTimeout(() => {
			setAppState({
				viewMode: {
					dummy: Math.random(),
					...this.props.viewMode
				}
			});
		}, 200);
	};

	render() {
		if (!this.props.open) {
			return null;
		}
		return (
			<Dialog open={this.props.open} onClose={this.handleClose}>
				<DialogTitle>
					<FormattedMessage id="DeleteSheetDialog.Title" defaultMessage="Delete StreamSheet" />
				</DialogTitle>
				<DialogContent
					style={{
						margin: '20px'
					}}
				>
					<DialogContentText>
						<FormattedMessage
							id="DeleteSheetDialog.Message"
							defaultMessage="This action can not be undone. Are you sure, you want to delete
								the StreamSheet: '{sheet}' ?"
							values={{ sheet: this.props.sheet ? this.props.sheet.name : ' ' }}
						/>
					</DialogContentText>
				</DialogContent>
				<Divider />
				<DialogActions>
					<DialogButton margin defaultButton onClick={this.props.close}>
						<FormattedMessage id="Dialog.Cancel" defaultMessage="Cancel" />
					</DialogButton>
					<DialogButton margin onClick={this.handleSubmitDeleteSheet}>
						<FormattedMessage id="Dialog.Delete" defaultMessage="Delete" />
					</DialogButton>
				</DialogActions>
			</Dialog>
		);
	}
}

SheetDeleteDialog.propTypes = {
	machineId: PropTypes.string.isRequired,
	sheet: PropTypes.object,
	open: PropTypes.bool.isRequired,
	close: PropTypes.func.isRequired,
	deleteStreamSheet: PropTypes.func.isRequired
};

SheetDeleteDialog.defaultProps = {
	sheet: undefined
};
function mapStateToProps(state) {
	return {
		viewMode: state.appState.viewMode,
	};
}

const mapDispatchToProps = {
	deleteStreamSheet
};

export default connect(mapStateToProps, mapDispatchToProps)(SheetDeleteDialog);
